<template>
  <div class="nav cf" id="boxFixed" :class="{ fixedNav: isFixed }">
    <ul class="clearfix">
      <li @click="gotoPage('/')">
        <a :class="{ open: activeStr == '' }" href="javascript:;">首页</a>
      </li>
      <li @click="gotoPage('/product')">
        <a :class="{ open: activeStr == 'product' }" href="javascript:;"
          >产品服务</a
        >
      </li>
      <li @click="gotoPage('/about')">
        <a :class="{ open: activeStr == 'about' }" href="javascript:;"
          >关于我们</a
        >
      </li>
      <li @click="gotoPage('/disclosure')">
        <a :class="{ open: activeStr == 'disclosure' }" href="javascript:;"
          >信息披露</a
        >
      </li>
      <li @click="gotoPage('/notice')">
        <a :class="{ open: activeStr == 'notice' }" href="javascript:;"
          >通知公告</a
        >
      </li>
      <!--<li><a target="_blank" href="http://www.awpbroker.com/gkxx.jhtml">信息披露</a></li>-->
      <li @click="gotoPage('/contact')">
        <a :class="{ open: activeStr == 'contact' }" href="javascript:;"
          >联系我们</a
        >
      </li>
      <!-- <li @click="gotoPCMallShop()"><a href="javascript:;">官方商城</a></li> -->
      <!--<a href="#" class="sousuo"><img src="../assets/image/nar_1.png" alt=""> 搜索</a>-->
    </ul>
    <!--<div class="sousuo rf">-->
    <!--<a>搜索</a>-->
    <!--<input name="page" type="text" placeholder="输入搜素关键字" v-model="value" id="search-head" />-->
    <!--</div>-->
  </div>
</template>
<script>
export default {
  name: "NavBar",
  data() {
    return {
      value: "",
      isFixed: false,
      activeStr: "",
      offsetTop: 0,
      about: ["contact", "team", "system", "introduction", "framework"]
    };
  },
  created() {
    this.activeStr = this.$route.path.split("/")[1];
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  },
  methods: {
    gotoPage(link) {
      this.$router.push({ path: link });
    },
    gotoPCMallShop() {
      // window.location.href = 'https://www.awpbroker.com/allianz-web-mall/home/index'
      window.open(
        "https://www.awpbroker.com/allianz-web-mall/home/index",
        "_blank"
      );
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量
      let offsetTop = document.querySelector("#boxFixed").offsetTop; // 要滚动到顶部吸附的元素的偏移量
      if (offsetTop > this.offsetTop) {
        this.offsetTop = offsetTop;
      }
      this.isFixed = scrollTop > this.offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
    }
  }
};
</script>
<style scoped>
.open {
  border-bottom-color: #e11b3c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue